import { render, staticRenderFns } from "./RoleParent.vue?vue&type=template&id=07b61d5d&scoped=true&"
import script from "./RoleParent.vue?vue&type=script&lang=js&"
export * from "./RoleParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b61d5d",
  null
  
)

export default component.exports